import type * as Dailies from './types'
import { cfDailyTileParser } from '../page/parsers/CFDailyPage'

export function dailiesParser(rawResponse: Dailies.Raw): Dailies.Parsed {
  const { tiles, lastEvaluatedKeyId, lastSort } = rawResponse
  return {
    lastEvaluated: {
      lastEvaluatedKeyId,
      lastSort,
    },
    dailies: tiles.map(cfDailyTileParser),
  }
}
